import component from './vi-VN/component';
import globalHeader from './vi-VN/globalHeader';
import menu from './vi-VN/menu';
import pages from './vi-VN/pages';
import pwa from './vi-VN/pwa';
import settingDrawer from './vi-VN/settingDrawer';
import settings from './vi-VN/settings';

export default {
  'navBar.lang': 'Ngôn ngữ',
  'layout.user.link.help': 'Trợ giúp',
  'layout.user.link.privacy': 'Quyền riêng tư',
  'layout.user.link.terms': 'Điều khoản',
  'app.copyright.produced': 'Hệ thống xếp hàng - Queue System',
  'app.preview.down.block': 'Tải xuống trang này',
  'app.welcome.link.fetch-blocks': 'Lấy tất cả các khối',
  'app.welcome.link.block-list': 'Xây dựng trang nhanh chóng',
  ...component,
  ...globalHeader,
  ...menu,
  ...pages,
  ...pwa,
  ...settingDrawer,
  ...settings,
};
